import { PlatformDependent } from '@/components/PlatformDependent'
import { LeaderboardViewDDE } from '@/views/GolfPricing/Tournament/Leaderboard/LeaderboardView.dde'

const LeaderboardView = () => (
  <>
    <PlatformDependent dde>
      <LeaderboardViewDDE />
    </PlatformDependent>
  </>
)

export default LeaderboardView
